







import { useConfigStore } from '@/store/config';
import { computed, defineComponent, toRefs } from '@vue/composition-api';
import HeaderInfo from './header-info.vue';

export default defineComponent({
  name: 'HeaderMini',
  components: {
    HeaderInfo,
  },
  setup() {
    const { config } = toRefs(useConfigStore());
    const miniImageUrl = computed(() => config.value.commonConfig.actConfig.miniHeaderImageUrl);
    return {
      miniImageUrl,
    };
  },
});
